const chatter = require('./src/chatter')

module.exports = chatter